import Tharidha from "../../../images/HomePage/Reviews/Tharidha.png";
import Krishna from "../../../images/HomePage/Reviews/Krishna.png";
import Prasanna from "../../../images/HomePage/Reviews/Prasanna.png";
import Prasad from "../../../images/HomePage/Reviews/Prasad.png";
import Dilki from "../../../images/HomePage/Reviews/Dilki.png";
import Kanes from "../../../images/HomePage/Reviews/Kanes.png";
import Tharaka from "../../../images/HomePage/Reviews/Tharaka.png";

export default [
  {
    author_name: "Tharidha Muhandiramge",
    text: "Exceptional service. Easiest way to get multiple quotes and select the best solution. Highly recommended.",
    relative_time_description: "",
    profile_photo_url: Tharidha,
    rating: 5,
  },
  {
    author_name: "krishna sym",
    text: "Thank you so much for helping to have my car insurance. Highly recommend. Special thanks to Ms.Puraja who was helping me through out the process",
    relative_time_description: "",
    profile_photo_url: Krishna,
    rating: 5,
  },
  {
    author_name: "Prasanna De Silva",
    text: "Insure me is not just another way of  getting an Insurance done. They supported me with multiple options and promptly educated with what market conditions are and things to consider with my next motor car policy renewal. The advises make sense. Even though you do a policy through them or not, InsureMe support is extended to the end. Good luck and recommended !",
    relative_time_description: "",
    profile_photo_url: Prasanna,
    rating: 5,
  },
  {
    author_name: "Prasad Eranga (FEEZOOZ)",
    text: "Very supportive to clients",
    relative_time_description: "",
    profile_photo_url: Prasad,
    rating: 5,
  },
  {
    author_name: "Dilki Perera",
    text: "Love this place. Excellent customer service",
    relative_time_description: "",
    profile_photo_url: Dilki,
    rating: 5,
  },
  {
    author_name: "Kanesavaradan Pitchaiappah",
    text: "Good place and discount for Credit cards",
    relative_time_description: "",
    profile_photo_url: Kanes,
    rating: 5,
  },
  {
    author_name: "Tharaka Madusanka",
    text: "I am happy that insureme was there to help me as they helped me in getting a good 3RD Party Insurance. Hope to be with them in future too.",
    relative_time_description: "",
    profile_photo_url: Tharaka,
    rating: 5,
  },
];
